import Cart from '../components/Cart';

export default [
  {
    name:      'cart',
    path:      '/cart',
    component: Cart,
  },
];



// WEBPACK FOOTER //
// ./src/apps/cart/router/index.js